/**
 * Directive: inputFieldError
 */
angular.module('acme.common.directive.inputFieldError', [])
.directive('inputFieldError', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/inputFieldError/inputFieldError.tpl.html',
      scope: {
        name: '@',
        message: '@'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.inputFieldError = {
          init: function(){}
        };

        $scope.inputFieldError.init();

      }]

    };

}]);